import { useState, useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import MobileBottomBar from '../../components/feature/MobileBottomBar';
import ReservationModal from '../../components/feature/ReservationModal';
import MasonryGrid from './components/MasonryGrid';

export default function GalleryPage() {
  const [reserveOpen, setReserveOpen] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="bg-cream min-h-screen">
      <Navbar />

      {/* Header */}
      <div className="relative pt-16 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('https://readdy.ai/api/search-image?query=vibrant%20colorful%20Indian%20restaurant%20interior%20mural%20art%20wall%20hand%20painted%20folk%20Bollywood%20art%20saffron%20teal%20warm%20golden%20lighting%20elegant%20dining%20atmosphere%20artistic%20cultural&width=1920&height=400&seq=1901&orientation=landscape')",
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-br from-charcoal/85 via-teal/70 to-saffron/75"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 sm:py-28 text-center">
          <p className="font-sans text-xs uppercase tracking-[0.3em] text-saffron mb-3">Chaska Indian Kitchen</p>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-white mb-4">Gallery</h1>
          <p className="font-sans text-base text-white/70 max-w-lg mx-auto">
            A visual journey through our food, our art, and the vibrant spirit of Chaska
          </p>
        </div>
      </div>

      {/* Gallery Content */}
      <main className="max-w-7xl mx-auto px-6 py-14 pb-28">
        <MasonryGrid />

        {/* CTA */}
        <div className="mt-20 text-center rounded-3xl overflow-hidden relative py-16 px-6">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: "url('https://readdy.ai/api/search-image?query=Indian%20restaurant%20table%20setting%20warm%20candlelight%20evening%20dining%20romantic%20atmosphere%20warm%20orange%20golden%20tones%20elegant%20professional%20photography&width=1200&height=400&seq=1902&orientation=landscape')",
            }}
          ></div>
          <div className="absolute inset-0 bg-gradient-to-r from-saffron/85 to-coral/85"></div>
          <div className="relative z-10">
            <h2 className="font-serif text-4xl sm:text-5xl text-white mb-4">Come Visit Us</h2>
            <p className="font-sans text-base text-white/80 mb-8 max-w-md mx-auto">
              Experience the colors, aromas and flavors of Chaska in person. We&apos;d love to have you
            </p>
            <button
              onClick={() => setReserveOpen(true)}
              className="bg-white text-coral font-sans font-bold text-sm px-10 py-4 rounded-full hover:bg-cream transition-colors cursor-pointer whitespace-nowrap"
            >
              Reserve Your Table
            </button>
          </div>
        </div>
      </main>

      <Footer />
      <MobileBottomBar onReserveClick={() => setReserveOpen(true)} />
      <ReservationModal isOpen={reserveOpen} onClose={() => setReserveOpen(false)} />
    </div>
  );
}
